<header class="" id="km-header">
  <nav class="navbar navbar-expand-lg p-0">
    <div class="km-navbar-brand text-lg-center">
      <div class="container">
        <div class="km-navbar-brand-btn-container">
          <a href="#">LOGIN</a> <a href="#">SIGN UP</a>
        </div>
      </div>
    </div>
    <div class="km-navbar-menu">
      <div class="container">
        <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
          <ul class="navbar-nav m-auto">
            <li class="nav-item active">
              <a class="nav-link" href="/home">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/daily">Daily</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="http://azkho.com/">Our Products</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">Blog</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/signin">Sign in</a>
            </li>
            <li class="nav-item km-cart px-0">
              <a class="nav-link" href="#">Cart <i aria-hidden="true" class="fa fa-shopping-cart fa-2x"></i> <span>1</span></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</header>
